import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
	title: {
		textAlign: 'center',
		[theme.breakpoints.down('xs')]:{
			marginTop: '150px'
		}
	},

}));
